import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import FinanceMatchmakerMonthlySettlementList from '../matchmaker/index';
export default {
  name: 'FinanceMonthlySettlementList',
  components: {
    FinanceMatchmakerMonthlySettlementList: FinanceMatchmakerMonthlySettlementList
  },
  data: function data() {
    return {
      activeName: 'first',
      apiUrl: process.env.VUE_APP_API,
      isSelect: this.checkauthority('finance_Monthly_Settlement_select'),
      isJS: this.checkauthority('finance_Monthly_Settlement_js'),
      isExport: this.checkauthority('finance_Monthly_Settlement_export'),
      selectForm: {
        mSettlementId: null,
        agencyId: null,
        settlementTime: null,
        settlementAccount: null,
        deductionsAccount: null,
        actualSettlement: null,
        createTime: null,
        settlementTimes: []
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      sumAccount: 0,
      updateAgencyDialogVisible: false,
      updateAgencyForm: {
        mSettlementId: null,
        userName: ''
      },
      updateAgencyRules: {
        userName: [{
          required: true,
          message: '代理账号不能为空',
          trigger: 'blur'
        }]
      },
      addSettlementDialogVisible: false,
      addSettlementForm: {
        phone: '',
        amount: undefined
      },
      addSettlementRules: {
        phone: [{
          required: true,
          message: '请输入结算账号',
          trigger: 'blur'
        }],
        amount: [{
          required: true,
          message: '请输入结算金额',
          trigger: 'change'
        }, {
          validator: function validator(rule, value, callback) {
            if (value !== undefined && value !== null && value !== '' && Number(value) <= 0) {
              callback(new Error('结算金额必须大于 0'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    /**
     * 单个结算。
     */
    settlement: function settlement(row) {
      var _this = this;
      this.$confirm('确定要进行结算操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.settlementApi(row.msettlementId);
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /**
     * 全部结算。
     */
    settlementAll: function settlementAll() {
      var _this2 = this;
      this.$confirm('确定要进行全部结算操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.settlementApi(null);
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /**
     * 不结算（删除该条结算数据）。
     */
    unSettlement: function unSettlement(row) {
      var _this3 = this;
      this.$confirm('此操作将永久删除该条结算数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.unSettlementApi(row);
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /**
     * 不结算Api
     * @param row 当前行数据
     * @returns {Promise<void>}
     */
    unSettlementApi: function unSettlementApi(row) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                msettlementId: row.mSettlementId !== undefined ? row.mSettlementId : row.msettlementId
              };
              _context.n = 1;
              return api.DELETE_AGENCYMONTHLYSETTLEMENT(par);
            case 1:
              _this4.$message.success('操作成功');
              _context.n = 2;
              return _this4.initTableData();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    exportExcel: function exportExcel() {
      var par = {};
      if (this.selectForm.settlementTimes.length >= 2) {
        par.startSettlementTime = this.selectForm.settlementTimes[0];
        par.endSettlementTime = this.selectForm.settlementTimes[1];
      } else {
        par.startSettlementTime = '';
        par.endSettlementTime = '';
      }
      window.open(this.apiUrl + 'admin/v1/agencyMonthlySettlement/export?startTime=' + par.startSettlementTime + '&endTime=' + par.endSettlementTime);
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: name
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this5.enumList = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this6 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.daleteApi(index, data);
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    /**
     * 结算Api
     * @param settlementId
     * @returns {Promise<void>}
     */
    settlementApi: function settlementApi(settlementId) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {};
              if (settlementId !== null) {
                par.settlementId = settlementId;
              }
              _context3.n = 1;
              return api.AGENCYMONTHLYSETTLEMENT(par);
            case 1:
              _this7.$message.success('操作成功');
              _context3.n = 2;
              return _this7.initTableData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getAgencyRemainAmountUnsettledCount: function getAgencyRemainAmountUnsettledCount() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.getAgencyRemainAmountUnsettledCount();
            case 1:
              res = _context4.v;
              _this8.sumAccount = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    daleteApi: function daleteApi(index, data) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                mSettlementId: data.mSettlementId
              };
              _context5.n = 1;
              return api.DELETE_AGENCYMONTHLYSETTLEMENT(par);
            case 1:
              _context5.n = 2;
              return _this9.initTableData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return api.DELETE_BATCH_AGENCYMONTHLYSETTLEMENT(par);
            case 1:
              _this0.$message.success('操作成功');
              _context6.n = 2;
              return _this0.initTableData();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this1 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this1.tableSelects.forEach(function (element) {
          par.push(element.mSettlementId);
        });
        _this1.deleteBatchApi(par);
      }).catch(function () {
        _this1.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.mSettlementId = null;
      this.selectForm.agencyId = null;
      this.selectForm.settlementTime = null;
      this.selectForm.settlementAccount = null;
      this.selectForm.deductionsAccount = null;
      this.selectForm.actualSettlement = null;
      this.selectForm.createTime = null;
      this.selectForm.settlementTimes = [];
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var par, res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              par = {
                pageNo: _this10.pageNo,
                pageSize: _this10.pageSize,
                settlementTime: _this10.selectForm.settlementTime
              };
              if (_this10.selectForm.settlementTimes.length >= 2) {
                par.startSettlementTime = _this10.selectForm.settlementTimes[0];
                par.endSettlementTime = _this10.selectForm.settlementTimes[1];
              }
              _context7.n = 1;
              return api.GET_AGENCYMONTHLYSETTLEMENT_FINANCE_PAGE_LIST(par);
            case 1:
              res = _context7.v;
              _this10.tableData = res.body.datas;
              _this10.pageTotal = res.body.sumDataCount;
              _this10.getAgencyRemainAmountUnsettledCount();
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    },
    openUpdateAgencyDialog: function openUpdateAgencyDialog(row) {
      this.updateAgencyForm.mSettlementId = row.msettlementId;
      this.updateAgencyForm.userName = '';
      this.updateAgencyDialogVisible = true;
    },
    updateSettlementAgency: function updateSettlementAgency() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _this11.$refs.updateAgencyForm.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(valid) {
                  var _t;
                  return _regenerator().w(function (_context8) {
                    while (1) switch (_context8.p = _context8.n) {
                      case 0:
                        if (!valid) {
                          _context8.n = 5;
                          break;
                        }
                        _context8.p = 1;
                        _context8.n = 2;
                        return api.updateSettlementAgency({
                          mSettlementId: _this11.updateAgencyForm.mSettlementId,
                          userName: _this11.updateAgencyForm.userName
                        });
                      case 2:
                        _this11.$message.success('修改成功');
                        _this11.updateAgencyDialogVisible = false;
                        _this11.initTableData();
                        _context8.n = 4;
                        break;
                      case 3:
                        _context8.p = 3;
                        _t = _context8.v;
                        _this11.$message.error(_t.message || '操作失败');
                      case 4:
                        _context8.n = 6;
                        break;
                      case 5:
                        return _context8.a(2, false);
                      case 6:
                        return _context8.a(2);
                    }
                  }, _callee8, null, [[1, 3]]);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    /**
     * 打开新增结算弹窗。
     */
    openAddSettlementDialog: function openAddSettlementDialog() {
      this.resetAddSettlementForm();
      this.addSettlementDialogVisible = true;
    },
    /**
     * 重置新增结算表单。
     */
    resetAddSettlementForm: function resetAddSettlementForm() {
      var _this12 = this;
      this.addSettlementForm.phone = '';
      this.addSettlementForm.amount = undefined;
      this.$nextTick(function () {
        if (_this12.$refs.addSettlementForm) {
          _this12.$refs.addSettlementForm.clearValidate();
        }
      });
    },
    /**
     * 提交新增结算。
     */
    saveArtificialSettlement: function saveArtificialSettlement() {
      var _this13 = this;
      if (!this.$refs.addSettlementForm) {
        return;
      }
      this.$refs.addSettlementForm.validate(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(valid) {
          var _t2;
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.p = _context0.n) {
              case 0:
                if (valid) {
                  _context0.n = 1;
                  break;
                }
                return _context0.a(2, false);
              case 1:
                _context0.p = 1;
                _context0.n = 2;
                return api.SAVE_ARTIFICIAL_SETTLEMENT({
                  phone: _this13.addSettlementForm.phone,
                  amount: _this13.addSettlementForm.amount
                });
              case 2:
                _this13.$message.success('操作成功');
                _this13.addSettlementDialogVisible = false;
                _this13.resetAddSettlementForm();
                _this13.initTableData();
                _context0.n = 4;
                break;
              case 3:
                _context0.p = 3;
                _t2 = _context0.v;
                _this13.$message.error(_t2.message || '操作失败');
              case 4:
                return _context0.a(2);
            }
          }, _callee0, null, [[1, 3]]);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initTableData();
  }
};